"use client";

import { c as _c } from "react/compiler-runtime";
import StreamingProvider from 'src/components/streaming/StreamingProvider';
import CinemaProvider from 'src/components/streaming/streamingtitlewithproviders/CinemaProvider';
import type ICommonDataStructure from "src/components/streaming/streamingtitlewithproviders/CommonDataStructure";
import LeftArrowSvg from 'src/components/svg/LeftArrowSvg';
import RightArrowSvg from 'src/components/svg/RightArrowSvg';
import { useEffect, useRef, useState } from 'react';
import classNames from 'classnames';
import styles from './ProviderScroller.module.css';

//#region [Props]
type ProviderScrollerProps = {
  data: ICommonDataStructure;
  isCinemaRelevant?: boolean;
  useCinemaRelevantProp?: boolean;
  className?: string;
};
//#endregion

//#region [Component]
export default function ProviderScroller(t0) {
  const $ = _c(27);
  const {
    data,
    isCinemaRelevant: t1,
    useCinemaRelevantProp: t2,
    className
  } = t0;
  const isCinemaRelevant = t1 === undefined ? false : t1;
  const useCinemaRelevantProp = t2 === undefined ? false : t2;
  const scrollContainer = useRef(null);
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = [true, false];
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  const [disabledStates, setDisabledStates] = useState(t3);
  let t4;
  let t5;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => {
      const curr = scrollContainer.current;
      let timer = null;
      const listener = e => {
        if (timer) {
          clearTimeout(timer);
          timer = null;
        }
        timer = setTimeout(() => {
          if (Math.round(curr.scrollLeft + curr.clientWidth) >= curr.scrollWidth) {
            setDisabledStates([false, true]);
          } else {
            if (curr.scrollLeft === 0) {
              setDisabledStates([true, false]);
            } else {
              setDisabledStates([false, false]);
            }
          }
        }, 200);
      };
      curr.addEventListener("scroll", listener);
      return () => {
        if (timer) {
          clearTimeout(timer);
        }
        if (curr) {
          curr.removeEventListener("scroll", listener);
        }
      };
    };
    t5 = [];
    $[1] = t4;
    $[2] = t5;
  } else {
    t4 = $[1];
    t5 = $[2];
  }
  useEffect(t4, t5);
  const showCinemaProvider = useCinemaRelevantProp ? isCinemaRelevant ?? data.isCinemaRelevant : data.isCinemaRelevant;
  const providerContents = data.providerContents;
  const t6 = showCinemaProvider && !providerContents?.length;
  let t7;
  if ($[3] !== className || $[4] !== t6) {
    t7 = classNames(styles.SProviderScrollerContainer, className, {
      [styles.CinemaOnly]: t6
    });
    $[3] = className;
    $[4] = t6;
    $[5] = t7;
  } else {
    t7 = $[5];
  }
  let t8;
  if ($[6] !== disabledStates || $[7] !== providerContents?.length) {
    t8 = (providerContents?.length ?? 0) > 2 && <button className={styles.SScrollerButton} disabled={disabledStates[0]} onClick={() => clickLeft(scrollContainer.current)}><LeftArrowSvg className={styles.SLeftArrowSvg} /></button>;
    $[6] = disabledStates;
    $[7] = providerContents?.length;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] !== data.filmwebMovieId || $[10] !== data.hasCinemaShows || $[11] !== data.premiereCinema || $[12] !== showCinemaProvider) {
    t9 = showCinemaProvider && !!data.filmwebMovieId && <CinemaProvider className={styles.SCinemaProvider} movieId={data.filmwebMovieId} premiere={data.premiereCinema} hasCinemaShows={data.hasCinemaShows} />;
    $[9] = data.filmwebMovieId;
    $[10] = data.hasCinemaShows;
    $[11] = data.premiereCinema;
    $[12] = showCinemaProvider;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== providerContents) {
    t10 = providerContents?.map(_temp);
    $[14] = providerContents;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== t10 || $[17] !== t9) {
    t11 = <div className={styles.SProviderList} ref={scrollContainer}>{t9}{t10}</div>;
    $[16] = t10;
    $[17] = t9;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== disabledStates || $[20] !== providerContents?.length) {
    t12 = (providerContents?.length ?? 0) > 2 && <button className={styles.SScrollerButton} disabled={disabledStates[1]} onClick={() => clickRight(scrollContainer.current)}><RightArrowSvg className={styles.SRightArrowSvg} /></button>;
    $[19] = disabledStates;
    $[20] = providerContents?.length;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== t11 || $[23] !== t12 || $[24] !== t7 || $[25] !== t8) {
    t13 = <div className={t7}>{t8}{t11}{t12}</div>;
    $[22] = t11;
    $[23] = t12;
    $[24] = t7;
    $[25] = t8;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  return t13;
}
//#endregion
function _temp(pc) {
  return <StreamingProvider className={styles.SStreamingProvider} key={pc?.id} providerContent={pc} />;
}
function clickRight(ref: HTMLDivElement | null) {
  ref?.scrollBy(ref?.getElementsByTagName('a')[2].offsetLeft, 0);
}
function clickLeft(ref: HTMLDivElement | null) {
  ref?.scrollBy(-1 * ref?.getElementsByTagName('a')[2].offsetLeft, 0);
}